const STORAGE_KEY = 'mca_vote_state_v1';

// Check if we're on the client side
const isClient = typeof window !== 'undefined';

function readState() {
  if (!isClient) {
    // Return default state on server
    return { user: null, selections: { site: [], fb: [], ott: [] } };
  }
  
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : { user: null, selections: { site: [], fb: [], ott: [] } };
  } catch {
    return { user: null, selections: { site: [], fb: [], ott: [] } };
  }
}

function writeState(next) {
  if (!isClient) {
    // No-op on server
    return;
  }
  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

export const voteStore = {
  saveUser(user) {
    const state = readState();
    state.user = user;
    writeState(state);
  },
  getUser() {
    return readState().user;
  },
  saveSelections(key, ids) {
    const state = readState();
    state.selections[key] = Array.isArray(ids) ? ids : [];
    writeState(state);
  },
  getSelections(key) {
    return readState().selections[key] || [];
  },
  getAll() {
    return readState();
  },
  clear() {
    writeState({ user: null, selections: { site: [], fb: [], ott: [] } });
  }
};
